export default __webpack_public_path__ + "static/media/galpao1.74a58f61.jpg";